import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';

const defaultState = {
	parameters: null,
	filters: '',
	pending: false,
	error: null,
	at: null,
	history : null,
	entryPasses: null,
	companies: null,
	export: { isLoading: false, error: null },
};

function apiReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.tepHistory.setParams.type:
			return { ...state, parameters: action.parameters, filters: action.filters, at: new Date() };
		case actions.tepHistory.loadHistory.type:
			return { ...state, pending: true, error: null };
		case actions.tepHistory.fail.type:
			return { ...state, pending: false, error: action.errorMessage };
		case actions.tepHistory.setEntryPasses.type:
			return { ...state, entryPasses: action.entryPasses, pending: false };
		case actions.tepHistory.setCompanies.type:
			return { ...state, companies: action.companies, pending: false };
		case actions.tepHistory.setHistory.type:
			return { ...state, history: action.history, pending: false };
		case actions.tepHistory.export.request.type:
			return { ...state, export: { isLoading: true, error: null } };
		case actions.tepHistory.export.success.type:
			return { ...state, export: { isLoading: false, error: null } };
		case actions.tepHistory.export.fail.type:
			return { ...state, export: { isExporting: false, error: action.errorMessage } };
		case actions.tepHistory.clear.type:
			return defaultState;
		default:
			return state;
	}
}

const reducer = reduxSwitch([apiReducer], defaultState);

export { reducer };
